module.exports = __webpack_public_path__ + "static/media/video_consent_audio_tamil.766f88d1.mp3";